import React, { useState, useEffect } from "react";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import Editor from "../TET/Editor";
import "./style.css";

const MessageModal = ({
  isModalOpen,
  toggleCancel,
  onSave,
  existingMessages = null,
  nodeTitle = "",
}) => {
  const [userMessage, setUserMessage] = useState("");
  const [amiMessage, setAmiMessage] = useState("");

  // Helper to extract text from HTML
  const getTitleFromHtml = (htmlContent) => {
    const div = document.createElement("div");
    div.innerHTML = htmlContent || "";
    return div.textContent || div.innerText || "Node";
  };

  useEffect(() => {
    if (existingMessages) {
      setUserMessage(existingMessages.userMessage || "");
      setAmiMessage(existingMessages.amiMessage || "");
    } else {
      setUserMessage("");
      setAmiMessage("");
    }
  }, [existingMessages, isModalOpen]);

  const handleReset = () => {
    setUserMessage("");
    setAmiMessage("");
  };

  const handleSave = () => {
    onSave({
      userMessage: userMessage,
      amiMessage: amiMessage,
    });
  };

  // Check if editor content is empty (excluding HTML tags)
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Disable save only if there is content but it's only spaces
  const hasOnlySpaces = (html) => {
    const stripped = stripHtml(html);
    return stripped.length > 0 && stripped.trim().length === 0;
  };

  const isSaveDisabled = hasOnlySpaces(userMessage) || hasOnlySpaces(amiMessage);

  return (
    <Modal
      className="adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <div className="editMessages-ami-modal-title">
        <h5>
          <strong>Set User and AMI Messages</strong>
        </h5>
      </div>
      <ModalBody>
        <div className="adminConfirmationModal-modal-body-content ami_editor">
          <h5 className="mb-3" style={{ color: "#071d49" }}>
            <strong>{getTitleFromHtml(nodeTitle)}</strong>
          </h5>
          <div className="form-group mb-3">
            <label htmlFor="userMessage" className="form-label">
              You:
            </label>
            <Editor textState={userMessage} onTextChange={setUserMessage} />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="amiMessage" className="form-label">
              Ami:
            </label>
            <Editor textState={amiMessage} onTextChange={setAmiMessage} />
          </div>
        </div>
        <div className="adminConfirmationModal-popup-button">
          <button
            type="button"
            onClick={handleSave}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
            disabled={isSaveDisabled}
          >
            Save
          </button>
          <button
            type="button"
            onClick={toggleCancel}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-secondary adminConfirmationModal-button btn-rounded"
          >
            Reset
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MessageModal;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AMI/MessageModal.js